import React, { useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { sortCaret, headerSortingClasses } from "../../../_metronic/_helpers";
import { useSelector, useDispatch } from "react-redux";
import { selectApproval, createApproval } from "./rejectSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
} from "../../utility";
function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

export const RejectDetail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const forceUpdate = useForceUpdate();

  const data = useSelector(selectApproval);

  // Add status field to prevent object is not extensible error
  const initData = data.map((item, index) => ({
    ...item,
    no: index + 1,
    status: null,
  }));

  const [tableData, setTableData] = useState(initData);
  console.log(tableData, "tabeldata");

  // Return if data null
  if (!tableData.length > 0) {
    history.push("/reject-return");
  }

  const handleSave = () => {
    // Validation
    let isValid = true;
    tableData.forEach((e) => {
      if (e.actual_qty === undefined) {
        isValid = false;
        return showErrorDialog("Please fill qty first!");
      }
      if (e.actual_qty === "") {
        isValid = false;
        return showErrorDialog("Please fill qty first!");
      }
    });
    if (!isValid) return;

    // Setup Request Body Params
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        availableQty: e.qty,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        oldReturnDetailId: e.returnDetailId,
        qty: e.actual_qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        customerCode: e.customerCode,
        line: e.line,
      };
    });

    const params = {
      invoiceNo: tableData[0].invoiceNo,
      customerCode: tableData[0].customerCode,
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      plantCode: tableData[0].plantCode,
      dataSource: tableData[0].dataSource,
      customerPODate: tableData[0].customerPODate,
      po: tableData[0].po,
      reasonCode: tableData[0].reasonCode,
      remark: tableData[0].remark,
      returnType: tableData[0].returnType,
      taxInvoiceNo: tableData[0].taxInvoiceNo,
      transactionDate: tableData[0].transactionDate,
      rtvNo: tableData[0].rtvNo,
      rtvDate: tableData[0].rtvDate,
      rtvReceivingDate: tableData[0].rtvReceivingDate,
      items: items,
    };
    console.log(params, "params");
    
    callApi(params);
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createApproval(params));
      if (response.payload.status === 200) {
        console.log(response, "respon");
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been saved, your return number : <strong>${response.payload.data.retNumber}</strong>`
        );
        if (action.isConfirmed) history.push("/reject-return");
      }
    } catch (error) {
      console.log("error", error);
      showErrorDialog("Something went wrong!");
    }
  };
  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const handleInputQtyChange = async (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].actual_qty = e.target.value;
    if (row.actual_qty > row.qty) {
      console.log(e, "code");

      forceUpdate();
      const action = await showErrorDialog(
        "please don't exceed requested qty "
      );
      if (action.isConfirmed) {
        row.actual_qty = row.qty;
        forceUpdate();
      }
    }
    setTableData(formatExtraData);
  };
  const inputQtyFormmater = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Control
        type="number"
        step="any"
        className="remark-brqa"
        // value={row.qty}
        onChange={(e) =>
          handleInputQtyChange(e, row, rowIndex, formatExtraData)
        }
      />
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "APL Sales Office",
      dataField: "plantname",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Doc Date",
      dataField: "docDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Qty",
      dataField: "qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RejectQty",
      dataField: "actual_qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: inputQtyFormmater,
      formatExtraData: tableData,
    },
    {
      text: "Uom",
      dataField: "uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Remark Reject by CW",
      dataField: "rejectRemarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Rejected By",
      dataField: "userName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reject Date",
      dataField: "reject_Date",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  return tableData.length > 0 ? (
    <Card>
      <CardHeader title="Reject Return List"></CardHeader>
      <CardBody>
        {/* Table */}
        <BootstrapTable
          wrapperClasses="table-responsive"
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
          bordered={false}
          keyField="returnDetailId"
          data={tableData}
          columns={columns}
          pagination={paginationFactory(options)}
          hover
        />

        {/* Footer */}
        <Form className="mt-14">
          <Row>
            <Col md="6" sm="6" lg="8">
              <Button variant="success" className="mr-5" onClick={handleSave}>
                Save
              </Button>
              <Button
                variant="secondary"
                className="mr-5"
                onClick={() => history.push("/reject-return")}
              >
                Back
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  ) : null;
};
